<div class="container-fluid">
  <!-- Header-->
  <header>
    <div class="row ey-header-container">
      <div class="col-sm-12">
        <h1 class="ey-header" style="display: inline-block">Privacy Notice</h1>
        <a
          [href]="documentFolder + 'TP_Benchmark_EY_Privacy_Notice.DOCX'"
          rel="noopener noreferrer"
          target="_blank"
          title="Download Privacy Notice"
          class="privayc-notice-download"
        >
          <i class="ey-menu-icon pi pi-download"></i>
        </a>
      </div>
    </div>
  </header>
  <!-- Header-->
  <!--Content-->
  <div class="ey-content mt-3 ey-privacy-notice-body-html">
    <div class="col-sm-12">
      <div class="ey-privacy-notice-body">
        <div class="row">
          <div class="col-12">
            <!--{{documentFolder}}-->
            <p class="header">1. Introduction</p>
            <div class="body">
              <p>
                This Privacy Notice is intended to describe the practices EY follows in relation to the TP Benchmark (“Tool”) with respect to the
                privacy of all individuals whose personal data is processed and stored in the Tool.
              </p>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <p class="header">2. Who manages the Tool?</p>
            <div class="body">
              <p>
                “EY” refers to one or more of the member firms of Ernst & Young Global Limited (“EYG”), each of which is a separate legal entity and
                can act as a data controller in its own right. The entity that is acting as data controller by providing this Tool on which your
                personal data will be processed and stored is EYGM Limited an EY global entity.
              </p>
              <p>
                The personal data you provide in the Tool is shared by EYGM Limited with one or more member firms of EYG (see
                <a (click)="scroll(dvAccessInfo)">“Who can access your information” </a> section below).
              </p>

              <p>
                The Tool is hosted on servers in the EY IT infrastructure and is hosted externally by the vendor or its third party hosting provider.
                The intent is to host the system in one or more Microsoft Azure data centres. The exact locations have not yet been determined, but
                will likely span an Americas (US) site, a Europe site and an Asia Pacific site.
              </p>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <p class="header">3. Why do we need your information?</p>
            <div class="body">
              <p>
                The Tool enables EY employees to filter databases when conducting a transfer pricing analysis. A transfer pricing analysis is used to
                compare similar prices for similar industries from publicly available databases. After the filtering, EY employees prepare benchmark
                studies.
              </p>

              <p>Your personal data processed in the Tool is used as follows:</p>
              <ul>
                <li>
                  EY employees insert their personal data to grant them access to the system and they are then able to use certain capabilities
                  available in the Tool (e.g. notifications, review, approval workflow, etc.).
                </li>
              </ul>

              <p>EY relies on the following basis to legitimize the processing of your personal data in the Tool:</p>
              <ul>
                <li>
                  Processing is necessary for the purposes of the legitimate interests pursued by the data controller or by a third party, except
                  where such interests are overridden by the interests or fundamental rights and freedoms of the data subject which require protection
                  of personal data. The specific legitimate interests are to conduct client engagements and comply with regulatory and legal
                  obligations.
                </li>
              </ul>
              <p>
                The provision of your personal data to EY is optional. However, if you do not provide all or part of your personal data, we may be
                unable to carry out the purposes for processing.
              </p>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <p class="header">4. What type of personal data is processed in the Tool?</p>
            <div class="body">
              <p>The Tool processes these personal data categories:</p>

              <ul>
                <li>EY employee's login credentials (Active Directory);</li>
                <li>EY employee's email address;</li>
                <li>EY employee's first name;</li>
                <li>EY employee's last name;</li>
                <li>EY employee's job title</li>
                <li>EY employee's rank</li>
                <li>EY employee's location data IP address and ID based on region</li>
              </ul>

              <p>
                This data is sourced from a feed from other EY systems (GHRDB and GHRS). The Tool will use the EY Active Directory (EYAD) to get login
                details of EY employees.
              </p>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <p class="header">5. Sensitive Personal Data</p>
            <div class="body">
              <p>
                Sensitive personal data reveals your racial or ethnic origin, political opinions, religious or philosophical beliefs, trade union membership, genetic data, biometric data, data concerning health or data concerning sex life or sexual orientation.
              </p>
    
              <p>
                EY does not intentionally collect any sensitive personal data from you via the Tool. The Tool’s intention is not to process such information. Accordingly, you should not enter any unnecessary personal information or any sensitive personal data (including government identifiers such as tax file numbers or social security numbers/national identification numbers), client confidential information (except client entity names), audit secrets, state secrets, trade secrets, or anything that would violate professional secrecy or confidentiality rules or that would be considered abusive/irrelevant in the Tool.
              </p>
            </div>
          </div>
        </div>

        <div class="row" #dvAccessInfo>
          <div class="col-12">
            <p class="header">6. Who can access your information?</p>
            <div class="body">
              <p>Your personal data is accessed in the Tool by the following persons/teams:</p>

              <p>Only EY personnel will have access to the Tool, specifically:</p>

              <ul>
                <li>EY International Tax Services (ITS) professionals;</li>
                <li>Tool development / support staff</li>
              </ul>

              <p>
                They will have access to read the data sourced from 3rd party vendor databases and view the aforementioned personal data of EY
                employees (name, email address, job title, rank, location).
              </p>

              <p>Access rights are determined on a hierarchical basis as shown in the following table:</p>
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th scope="col">User Role</th>
                    <th scope="col">Description</th>
                    <th>Located</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Study Analyst</td>
                    <td>
                      Initiate project set up, perform search/review comparable data, add filters, update filters, select database, update database,
                      export data, import data, create reports, leverage existing search.
                    </td>
                    <td>Globally</td>
                  </tr>
                  <!--<tr>
                    <td>Reviewer </td>
                    <td>Review entire study, Modify results, Review filter data (optional) </td>
                    <td>Globally</td>
                  </tr>
                  <tr>
                    <td>Approver </td>
                    <td>Approve Reports for client (final deliverables) </td>
                    <td>Globally</td>
                  </tr>-->
                  <tr>
                    <td>Study Admin</td>
                    <td>
                      Access to the entire system, add/remove users to/from studies (does not have to be assigned to study), Lock/unlock a study.
                    </td>
                    <td>Globally</td>
                  </tr>
                  <tr>
                    <td>Viewer</td>
                    <td>View access only</td>
                    <td>Globally</td>
                  </tr>
                  <tr>
                    <td>System Admin</td>
                    <td>Unrestricted access to the tool and all the studies. (system logs, security, etc.)</td>
                    <td>Globally</td>
                  </tr>
                </tbody>
              </table>

              <p>
                The access rights detailed above involves transferring personal data in various jurisdictions (including jurisdictions outside the
                European Union) in which EY operates (EY office locations are listed at
                <a href="http://www.ey.com/ourlocations" rel="noopener noreferrer" target="_blank">www.ey.com/ourlocations</a> ). EY will process your
                personal data in the Tool in accordance with applicable law and professional regulations in your jurisdiction. Transfers of personal
                data within the EY network are governed by EY's Binding Corporate Rules (<a
                  href="http://www.ey.com/bcr"
                  rel="noopener noreferrer"
                  target="_blank"
                  >www.ey.com/bcr</a
                >).
              </p>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <p class="header">7. Data retention</p>
            <div class="body">
              <p>The policies and/or procedures for the retention of personal data in the Tool are:</p>

              <ul>
                <li>personal data will be retained and disposed is in accordance with EY Records Retention Global Policy;</li>
                <li>personal data will only be retained in line with EY's business need;</li>
                <li>personal data is deleted by an automatic process; and</li>
                <li>personal data will be retained in a separate archive system before it is permanently deleted.</li>
              </ul>
              <p>Your personal data will be retained in compliance with privacy laws and regulations.</p>
              <p>After the end of the data retention period, your personal data will be deleted.</p>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <p class="header">8. Security</p>
            <div class="body">
              <p>
                EY is committed to making sure your personal data is secure. To prevent unauthorized access or disclosure, EY has technical and
                organizational measures to safeguard and secure your personal data. All EY personnel and third parties EY engages to process your
                personal data are obliged to respect your data's confidentiality.
              </p>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <p class="header">9. Controlling your personal data</p>
            <div class="body">
              <p>
                EY will not transfer your personal data to third parties (other than any external parties referred to in section 6 above) unless we
                have your permission or are required by law to do so.
              </p>
              <p>You are legally entitled to request details of EY's personal data about you.</p>
              <p>
                To confirm whether your personal data is processed in the Tool or to access your personal data in the Tool, contact your usual EY
                representative or email your request to <a href="mailto:global.data.protection@ey.com">global.data.protection@ey.com</a>.
              </p>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <p class="header">10. Rectification, erasure, restriction of processing or data portability</p>
            <div class="body">
              <p>
                You can confirm your personal data is accurate and current. You can request rectification, erasure, restriction of processing or a
                readily portable copy of your personal data by contacting your usual EY representative or by sending an e-mail to
                <a href="mailto:global.data.protection@ey.com">global.data.protection@ey.com</a>
              </p>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <p class="header">11. Complaints</p>
            <div class="body">
              <p>
                If you are concerned about an alleged breach of privacy law or any other regulation, contact EY's Global Privacy Officer, Office of
                the General Counsel, 6 More London Place, London, SE1 2DA, United Kingdom or via email at
                <a href="mailto:global.data.protection@ey.com">global.data.protection@ey.com</a> or via your usual EY representative. An EY Privacy
                Officer will investigate your complaint and provide information about how it will be handled and resolved.
              </p>
              <p>
                If you are not satisfied with how EY resolved your complaint, you have the right to complain to your country's data protection
                authority. You can also refer the matter to a court of competent jurisdiction.
              </p>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <p class="header">12. Contact us</p>
            <div class="body">
              <p>
                If you have additional questions or concerns, contact your usual EY representative or email
                <a href="mailto:global.data.protection@ey.com">global.data.protection@ey.com</a>.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--Content-->
</div>
